/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Pencil({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M11.305 0a2.5 2.5 0 0 0-1.769.733l-8.39 8.39a.5.5 0 0 0-.136.256l-1 5a.5.5 0 0 0 .588.588l5-1a.5.5 0 0 0 .256-.137l8.132-8.133-.486-.03s-.5.144-1.041.144l-7.205 7.205-4.117.823.824-4.116 8.283-8.283a1.5 1.5 0 0 1 2.122 0l1.17 1.17a1.5 1.5 0 0 1 0 2.123L12.46 5.811c.541 0 1.041-.144 1.041-.144l.486.03.258-.257a2.5 2.5 0 0 0 0-3.537l-1.17-1.17A2.5 2.5 0 0 0 11.305 0" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="m5.157 13.824-4.01-3.99.706-.708 4.01 3.99z" clipRule="evenodd" /></svg>;
}
;